export default {"src":"/_next/static/media/refresh-icon-mobile.c1d45da2.svg","height":26,"width":26};